import { initializeApp, getApps, getApp, deleteApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { firebaseConfig } from './config';

function getFirebaseApp() {
  if (getApps().length) {
    const existing = getApp();
    const existingId = existing.options?.projectId;
    if (existingId && firebaseConfig.projectId && existingId !== firebaseConfig.projectId) {
      console.warn(
        `[Firebase] Replacing stale app "${existingId}" with "${firebaseConfig.projectId}"`
      );
      try {
        deleteApp(existing);
      } catch (e) {
        console.warn('[Firebase] Could not delete stale app - hard refresh / restart npm start', e);
        return existing;
      }
    } else {
      return existing;
    }
  }
  return initializeApp(firebaseConfig);
}

const app = getFirebaseApp();
export const auth = getAuth(app);
export const db = getFirestore(app);
export const firebaseProjectId = firebaseConfig.projectId || 'unknown';
